import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

import { SharedService } from 'baseline-lib';
import { Market } from 'baseline-lib';
import { CombinationBet, Selection } from 'baseline-lib';
import { MobileSharedService } from 'baseline-lib';
import { EventListing } from 'baseline-lib';
import { EventListingService } from 'baseline-lib';
import { VirtualListingService } from 'baseline-lib';

 
@Component({
  selector: 'app-market-listing',
  templateUrl: './market-listing.html'
})
export class MarketListingComponent implements OnInit {

  @Input()  eventId : number;
   
  EventListObj: EventListing;
  toggleOrder:boolean = true;
  toggleOrder2:boolean = false;
  // for enabling placeBet buttons
  toggleBetInOrder : boolean = false;
  toggleBetOutOfOrder : boolean = false;

  combBetMap :   Map<number, CombinationBet[] >  = new   Map<number, CombinationBet[]> ();

  // to display total combinations on UI
  inOrderCombinations : number[] = [0,0];
  outOfOrderCombinations : number[] = [0,0];

  // for internal usage
  MIN_TWO : number = 2;
  MIN_THREE : number = 3;

   

   constructor( 
   public mobileSharedService: MobileSharedService,
   private _virtualListingService : VirtualListingService,
   private _eventListingService: EventListingService,
   private _sharedService : SharedService
   ) {
   this.EventListObj = new EventListing();
   this.toggleOrder = true;
 }

 ngOnInit() {
  }

 noOfSelections(index : number , order : boolean)
 {
   let  data : number[] =[];
   if(order)
   {
     for(let i= 1;i<=index ;i++)
       data.push(i);
   }
   else
     data.push(1)  ;

   return data;
 }

 ngOnChanges(changes: SimpleChanges) {

     if (changes.eventId) {
      this._sharedService.showLoader();
     this.eventId =  changes.eventId.currentValue as number;
     this.EventListObj = this._eventListingService.EventListObj;
     this.reset();
     this._sharedService.hideLoader();
     }
  }

 reset()
 {
   this.toggleOrder = true;
   this.combBetMap =new   Map<number, CombinationBet[]> ();
   this.toggleBetInOrder = false;
   this.toggleBetOutOfOrder = false;
   this.inOrderCombinations =   [0,0];
   this.outOfOrderCombinations =  [0,0];
   }

 // on selection of comination bets
 //selectionType -- forecast, tricast , reverseforecast , reversetricast
 combBetClick(_combBet : CombinationBet,market : Market , _indexNum : number, selectionType :number)
 {
    let removeBetSelection : boolean = false;
   // for in order combination bets selection

   if(! this.combBetMap.get(market.mid))
   this.combBetMap.set(market.mid , []);

   if(! this.combBetMap.get(market.mid).includes(_combBet)) 
     this.combBetMap.get(market.mid).push(_combBet);

     switch(market.mid)
     {
       case 1 : 
           if( !_combBet.check[0] && !_combBet.check[1])
             removeBetSelection =true;
           break;
       case 2 : 
           if( !_combBet.check[0] && !_combBet.check[1] && !_combBet.check[2])
               removeBetSelection =true;
           break;    
       case 3:
       case 4: 
             if( !_combBet.check[0])
               removeBetSelection =true;
             break;  
       }
     if(removeBetSelection)
       this.combBetMap.get(market.mid).splice(this.combBetMap.get(market.mid).indexOf(_combBet));


  this.calculateCombinations(market , selectionType);
 }

 toggleOrderVal(){
   this.toggleOrder = !this.toggleOrder;
 }
 sbet(){
   this.toggleOrder2 = !this.toggleOrder2 ;
 }
 // on click of odds selection
 BetSelection(_selection: Selection, market: Market) {
    this._virtualListingService.BetSelection(_selection,market, this.EventListObj.selectedEvent ,this.EventListObj.gameObj);
 }

 // on click of odds selection for combinations
 BetSelectionCombination() {
      this._virtualListingService.getEventCombinationOdds(this.toggleOrder, this.combBetMap , this.EventListObj.selectedEvent , this.EventListObj);
     this.clearCombBetSelection(false);
  }

 // to clear combination bets selection
 clearCombBetSelection(flagClearData : boolean)
 {
   if(flagClearData)
   {
     this.EventListObj.eventList.filter(_event => _event.eventid == this.EventListObj.selectedEvent.eventid )[0].
     mli.filter(_m => _m.spec && _m.spec.order == this.toggleOrder).forEach(_market => 
       { 
         if(_market.spec.order == this.toggleOrder)
         {
           _market.sli.forEach(_sel => 
           {
             _sel.combinationBet.resetCombinations()
             if( this.combBetMap.get(_market.mid))
               this.combBetMap.delete(_market.mid);
           })
         }
     });
   }
   if(this.toggleOrder)
   {     
     this.toggleBetInOrder = false;
     this.inOrderCombinations =  [0,0];
   }
   else
   {
      this.toggleBetOutOfOrder = false;
      this.outOfOrderCombinations =  [0,0];
   }
 }
 

// calculate combinations
calculateCombinations(market : Market, selectionType : number)
{
   var selectedEntries : Selection[] =[];
   switch(selectionType)
   {
     case 1 :
     case 2: 
       if(market.spec.order)
           this.calculatePermCombination(market, selectionType);
       else 
       {
         this.toggleBetOutOfOrder = false;
         selectedEntries = market.sli.filter(e => e.combinationBet.check[0]).sort((a1,a2) => a1.combinationBet.sseq - a2.combinationBet.sseq);
         if(selectedEntries.length >= market.spec.nofsel)
         {
             this.calculateAnyOrderCombination(market, selectionType, selectedEntries);
         }
        }
       break;
   }
}

 // to add  combination string to map
 addCombToSelections(market,en1,en2,en3)
 {  
    var selStr =en1+'-'+en2 ;
   if(en3!=-1)
     selStr+='-'+en3 ;
   
   this.combBetMap.get(market.mid).values().next().value.combinationStr.push(selStr);

     if(market.spec.order)
     {
      this.toggleBetInOrder = true;
     }  
     
     if(!market.spec.order)
      {  
        this.toggleBetOutOfOrder = true;
      }
 }


 calculateAnyOrderCombination(market : Market , _combBetType, selectedEntries: Selection[])
 {
     let combCount =0 , indx =1 , indx1 =1, indx2 =1;
     this.toggleBetOutOfOrder = true;
     market.sli.sort(function(a, b){
         return a.sseq-b.sseq;
     });

     if(this.combBetMap.get(market.mid))
       this.combBetMap.get(market.mid).values().next().value.combinationStr = [];

      // for 1st TWO selections
   if(_combBetType == 1)
   {
      this.outOfOrderCombinations[0] =0 ;
     
         selectedEntries.forEach(_entry =>
           {
               indx1 =1;
               selectedEntries.forEach(_entry1 => {
   
                 if(indx1 > indx )
                 {
                      this.addCombToSelections(market,  _entry.combinationBet.sseq, _entry1.combinationBet.sseq, -1);
                 }
                   indx1 ++;
               });
               indx ++ ;
           });
      this.outOfOrderCombinations[0] = this.combBetMap.get(market.mid).values().next().value.combinationStr.length;
           
   } 
   else if(_combBetType == 2)
   {
     this.outOfOrderCombinations[1] =0 ;
     
          selectedEntries.forEach(_entry =>
           {
               indx1 =1;
               selectedEntries.forEach(_entry1 => {
                
                 indx2 =1 ;
                 
                 if(indx1 > indx )
                 {
                   selectedEntries.forEach(_entry2 => {
   
                     if(indx2 > indx1)
                     { 
                         this.addCombToSelections(market, _entry.combinationBet.sseq, _entry1.combinationBet.sseq, _entry2.combinationBet.sseq);
                     }
                     indx2++;
                   });
                 } 
                 indx1 ++;
               });
               indx ++ ;
           });
       this.outOfOrderCombinations[1] = this.combBetMap.get(market.mid).values().next().value.combinationStr.length;    
     }
  }

 // for 1st 2 and 1st 3
 calculatePermCombination(market , _combBetType)
 {
   let combCount =0 , indx =1 , indx1 =1, indx2 =1;
   if(this.combBetMap.get(market.mid))
     this.combBetMap.get(market.mid).values().next().value.combinationStr = [];

     // for 1st TWO selections
   if(_combBetType == 1)
   {
      this.toggleBetInOrder = false;
      market.sli.forEach(_entry =>
       {
           indx1 =1;
           market.sli.forEach(_entry1 => {

             if(indx1 > indx )
             { 
               if(_entry.combinationBet.check[0] && _entry1.combinationBet.check[1])
               {
                 combCount++;
                 this.addCombToSelections(market, _entry.combinationBet.sseq, _entry1.combinationBet.sseq,-1);
                }

               if(_entry.combinationBet.check[1] && _entry1.combinationBet.check[0])
               {
                 combCount++;
                 this.addCombToSelections(market, _entry1.combinationBet.sseq, _entry.combinationBet.sseq,-1);
               }
             }
               indx1 ++;
           });
           indx ++ ;
       });
       this.inOrderCombinations[0] = combCount ;
   }
   // for 1st THREE selections
   else if(_combBetType == 2)
   {
      this.toggleBetInOrder = false;
      market.sli.forEach(_entry =>
       {
           indx1 =1;
           market.sli.forEach(_entry1 => {
            
             indx2 =1 ;
             
             if(indx1 > indx )
             {
               market.sli.forEach(_entry2 => {

                 if(indx2 > indx1)
                 { 
                   if(_entry.combinationBet.check[0] && _entry1.combinationBet.check[1] && _entry2.combinationBet.check[2])
                   {
                     combCount++;
                     this.addCombToSelections(market, _entry.combinationBet.sseq, _entry1.combinationBet.sseq,_entry2.combinationBet.sseq);
                    }
                    if(_entry.combinationBet.check[0] && _entry1.combinationBet.check[2] && _entry2.combinationBet.check[1])
                    {
                     combCount++;
                     this.addCombToSelections(market, _entry.combinationBet.sseq, _entry2.combinationBet.sseq,_entry1.combinationBet.sseq);
                   }

                   if(_entry.combinationBet.check[1] && _entry1.combinationBet.check[0] && _entry2.combinationBet.check[2])
                   {
                     combCount++;
                     this.addCombToSelections(market, _entry1.combinationBet.sseq, _entry.combinationBet.sseq,_entry2.combinationBet.sseq);
                    }

                    if(_entry.combinationBet.check[1] && _entry1.combinationBet.check[2] && _entry2.combinationBet.check[0])
                   {
                     combCount++;
                     this.addCombToSelections(market, _entry2.combinationBet.sseq, _entry.combinationBet.sseq,_entry1.combinationBet.sseq);
                    }

                    if(_entry.combinationBet.check[2] && _entry1.combinationBet.check[1] && _entry2.combinationBet.check[0])
                   {
                     combCount++;
                     this.addCombToSelections(market, _entry2.combinationBet.sseq, _entry1.combinationBet.sseq,_entry.combinationBet.sseq);
                    }

                    if(_entry.combinationBet.check[2] && _entry1.combinationBet.check[0] && _entry2.combinationBet.check[1])
                    
                   {
                     combCount++;
                     this.addCombToSelections(market, _entry1.combinationBet.sseq, _entry2.combinationBet.sseq,_entry.combinationBet.sseq);
                    }
                 }
                 indx2++;
               });
             } 
             indx1 ++;
           });
           indx ++ ;
       });
       this.inOrderCombinations[1] = combCount ;
   }
 }

 showLbwPopup(_eid) {
   var el: HTMLElement = document.getElementById(_eid+'_ref');
   
   let outputLbl  = Array.from( document.getElementById(_eid+'_ref').getElementsByTagName('output'));
   let i=0;
   const frameZones = Array.from( document.getElementById(_eid+'_ref').getElementsByTagName('input'));
   frameZones.forEach( element  => {
   
     var topOffset = 60;
     let value = Number(element.value );
     let width : number = 115 - (115 * ( value /  Number(element.max )));
     topOffset = topOffset + (i * 10) +  (i * 15);
     if(value == 0)
        width = -15;
     outputLbl[i].setAttribute("style","margin-left:"+width+'px'+" ;top : "+ topOffset+'px');
     i++;
   });
 }

}


// WEBPACK FOOTER //
// ./src/app/virtual-sports/market-listing/market-listing.ts